import { useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

const useTheme = () => {
  const themeMode = useSelector((state) => _.get(state, "general.themeMode", "light"));

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", themeMode);
  }, [themeMode]);

  return themeMode;
};

export default useTheme;
